import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapFloatingButton = React.lazy(function () {
    return import('../../bootstrap-components/components/BTFloatingButton');
});
var bootStrapFloatingButton = function (props) {
    return (React.createElement(BootStrapFloatingButton, __assign({}, props)));
};
var FloatingButton = function (props) {
    var componentToDisplay = bootStrapFloatingButton(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapFloatingButton(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
FloatingButton.defaultProps = {
    styleName: 'primary',
    menuLabel: 'ButtonTest',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(FloatingButton);
//# sourceMappingURL=FloatingButton.js.map